<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="Edit Lead" @close="close()" />
      <v-card-text>

        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-text-field autofocus outlined dense :error-messages="fatherNameErrors"
              :background-color="`${Lead.fatherName ? false : '#E8F5E9'}`" :hide-details="fatherNameErrors.length === 0"
              v-model="Lead.fatherName" label="Father's Name">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field type="tel" outlined dense v-mask="'(###) ###-####'"
              :background-color="`${Lead.fatherPhoneNumber ? false : '#E8F5E9'}`"
              :error-messages="fatherPhoneNumberErrors" :hide-details="fatherPhoneNumberErrors.length === 0"
              v-model="Lead.fatherPhoneNumber" label="Father's Primary Number"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12">
            <v-text-field outlined dense :error-messages="fatherEmailAddressErrors"
              :background-color="`${Lead.fatherEmailAddress ? false : '#E8F5E9'}`" :hide-details="fatherEmailAddressErrors.length === 0
                " @change="fixFatherEmail" v-model="Lead.fatherEmailAddress" label="Father's Email">
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-text-field outlined dense hide-details v-model="Lead.motherName" label="Mother's Name">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field outlined dense hide-details v-mask="'(###) ###-####'" type="tel"
              v-model="Lead.motherPhoneNumber" label="Mother's Primary Number"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12">
            <v-text-field outlined dense :error-messages="motherEmailAddressErrors" :hide-details="motherEmailAddressErrors.length === 0
              " @change="fixMotherEmail" v-model="Lead.motherEmailAddress" label="Mother's Email">
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-text-field outlined dense :error-messages="emergencyNameErrors"
              :background-color="`${Lead.emergencyName ? false : '#E8F5E9'}`"
              :hide-details="emergencyNameErrors.length === 0" v-model="Lead.emergencyName" label="Name">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field outlined dense v-mask="'(###) ###-####'" type="tel"
              :background-color="`${Lead.emergencyPhoneNumber ? false : '#E8F5E9'}`"
              :error-messages="emergencyPhoneNumberErrors" :hide-details="emergencyPhoneNumberErrors.length === 0
                " v-model="Lead.emergencyPhoneNumber" label="Phone Number"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field outlined :error-messages="emergencyRelationErrors"
              :background-color="`${Lead.emergencyRelation ? false : '#E8F5E9'}`"
              :hide-details="emergencyRelationErrors.length === 0" dense v-model="Lead.emergencyRelation"
              label="Relation"></v-text-field>
          </v-col>


          <v-col cols="12" sm="12">
            <v-text-field outlined :error-messages="addressErrors"
              :background-color="`${Lead.address ? false : '#E8F5E9'}`" :hide-details="addressErrors.length === 0" dense
              v-model="Lead.address" label="Address">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field outlined hide-details dense @change="Lead.city = properCase(Lead.city)" v-model="Lead.city"
              label="City"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field outlined dense hide-details v-model="Lead.state" label="State"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field outlined dense hide-details v-model="Lead.zip" label="Zip Code"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12">
            <v-textarea outlined dense hide-details auto-grow v-model="Lead.note" :label="$t('labels.note')">
            </v-textarea>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import LeadService from "../service.js";
import GlobalFunction from "@/mixins/GlobalFunction";
import _ from "lodash";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

export default {
  props: {
    editDialog: {
      default: false,
    },
    editLead: {
      type: Object,
    },
  },
  name: "update-Lead",
  data() {
    return {
      leadStatus: ["Open", "Contacted", "Waiting", "Closed", "Convert"],
      loading: false,
      dialog: false,
      Student: {
        firstName: null,
        lastName: null,
        dob: null,
        selectedClass: null,
        ClassId: null,
      },
      Lead: {
        fatherName: null,
        fatherPhoneNumber: null,
        fatherEmailAddress: null,
        motherName: null,
        motherPhoneNumber: null,
        motherEmailAddress: null,
        emergencyName: null,
        emergencyPhoneNumber: null,
        emergencyRelation: null,
        address: null,
        city: null,
        state: "NY",
        zip: null,
      },
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    studentFirstNameErrors() {
      const errors = [];
      if (!this.$v.Student.firstName.$dirty) return errors;
      if (!this.$v.Student.firstName.required)
        errors.push("First Name is required");
      return errors;
    },
    studentLastNameErrors() {
      const errors = [];
      if (!this.$v.Student.lastName.$dirty) return errors;
      if (!this.$v.Student.lastName.required)
        errors.push("Last Name is required");
      return errors;
    },
    dobError() {
      const errors = [];
      if (!this.$v.Student.dob.$dirty) return errors;
      if (!this.$v.Student.dob.required)
        errors.push("Date of birth is required");
      return errors;
    },
    classIdErrors() {
      const errors = [];
      if (!this.$v.Student.selectedClass.$dirty) return errors;
      if (!this.$v.Student.selectedClass.required)
        errors.push("Class is required");
      // if (!this.$v.Product.selectedClass.minValue) errors.push("Please Select Department");

      return errors;
    },
    genderErrors() {
      const errors = [];
      if (!this.$v.Student.gender.$dirty) return errors;
      if (!this.$v.Student.gender.required) errors.push("Gender is required");

      return errors;
    },
    // emergencyNameErrors() {
    //   const errors = [];
    //   if (!this.$v.Lead.emergencyName.$dirty) return errors;
    //   if (!this.$v.Lead.emergencyName.required)
    //     errors.push("Name is required");
    //   return errors;
    // },
    // emergencyPhoneNumberErrors() {
    //   const errors = [];
    //   if (!this.$v.Lead.emergencyPhoneNumber.$dirty) return errors;
    //   if (!this.$v.Lead.emergencyPhoneNumber.required)
    //     errors.push("Phone Number is required");
    //   return errors;
    // },
    // emergencyRelationErrors() {
    //   const errors = [];
    //   if (!this.$v.Lead.emergencyRelation.$dirty) return errors;
    //   if (!this.$v.Lead.emergencyRelation.required)
    //     errors.push("Relation is required");
    //   return errors;
    // },
    fatherNameErrors() {
      const errors = [];
      if (!this.$v.Lead.fatherName.$dirty) return errors;
      if (!this.$v.Lead.fatherName.required) errors.push("Name is required");
      return errors;
    },
    fatherPhoneNumberErrors() {
      const errors = [];
      if (!this.$v.Lead.fatherPhoneNumber.$dirty) return errors;
      if (!this.$v.Lead.fatherPhoneNumber.required)
        errors.push("Phone Number is required");
      return errors;
    },
    fatherEmailAddressErrors() {
      const errors = [];
      if (!this.$v.Lead.fatherEmailAddress.$dirty) return errors;
      if (!this.$v.Lead.fatherEmailAddress.required)
        errors.push("Email Address is required");
      if (!this.$v.Lead.fatherEmailAddress.email)
        errors.push("Email is not valid");
      return errors;
    },
    motherEmailAddressErrors() {
      const errors = [];
      if (!this.$v.Lead.motherEmailAddress.$dirty) return errors;
      if (!this.$v.Lead.motherEmailAddress.email)
        errors.push("Email is not valid");
      return errors;
    },
    addressErrors() {
      const errors = [];
      if (!this.$v.Lead.address.$dirty) return errors;
      if (!this.$v.Lead.address.required) errors.push("Address is required");
      return errors;
    },
    cityErrors() {
      const errors = [];
      if (!this.$v.Lead.city.$dirty) return errors;
      if (!this.$v.Lead.city.required) errors.push("City is required");
      return errors;
    },
    stateErrors() {
      const errors = [];
      if (!this.$v.Lead.state.$dirty) return errors;
      if (!this.$v.Lead.state.required) errors.push("State is required");
      return errors;
    },
    zipErrors() {
      const errors = [];
      if (!this.$v.Lead.zip.$dirty) return errors;
      if (!this.$v.Lead.zip.required) errors.push("Zip Code is required");
      return errors;
    },
    emergencyNameErrors() {
      const errors = [];
      if (!this.$v.Lead.emergencyName.$dirty) return errors;
      if (!this.$v.Lead.emergencyName.required)
        errors.push("Name is required");
      return errors;
    },
    emergencyPhoneNumberErrors() {
      const errors = [];
      if (!this.$v.Lead.emergencyPhoneNumber.$dirty) return errors;
      if (!this.$v.Lead.emergencyPhoneNumber.required)
        errors.push("Phone Number is required");
      return errors;
    },
    emergencyRelationErrors() {
      const errors = [];
      if (!this.$v.Lead.emergencyRelation.$dirty) return errors;
      if (!this.$v.Lead.emergencyRelation.required)
        errors.push("Relation is required");
      return errors;
    },
  },
  watch: {
    editDialog(val) {
      this.Lead = _.clone(this.editLead);
      this.dialog = val;
    },
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    Lead: {
      fatherName: {
        required,
      },
      fatherPhoneNumber: {
        required,
      },
      fatherEmailAddress: {
        required,
        email,
      },
      motherEmailAddress: {
        email,
      },
      emergencyName: {
        required,
      },
      emergencyPhoneNumber: {
        required,
      },
      emergencyRelation: {
        required,
      },
      address: {
        required,
      },
      city: {
        required,
      },
      state: {
        required,
      },
      zip: {
        required,
      },
    },
    // Student: {
    //   firstName: {
    //     required,
    //   },
    //   lastName: {
    //     required,
    //   },
    //   dob: {
    //     required,
    //   },
    //   gender: {
    //     required,
    //   },
    //   selectedClass: {
    //     required,
    //   },
    // },
  },
  methods: {
    fixFatherEmail() {
      this.Lead.fatherEmailAddress = this.Lead.fatherEmailAddress
        .toLowerCase()
        .trim();
    },
    fixMotherEmail() {
      this.Lead.motherEmailAddress = this.Lead.motherEmailAddress
        .toLowerCase()
        .trim();
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Lead = {
        name: null,
        email: null,
        phoneNumber: null,
        contactName: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        note: null,
        status: "Hot Lead",
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      console.log('this.$v', this.$v)
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        if (this.Lead.fatherPhoneNumber) {
          this.Lead.fatherPhoneNumber = this.Lead.fatherPhoneNumber.replace(
            /[^a-zA-Z0-9]/g,
            ""
          );
        }

        if (this.Lead.motherPhoneNumber) {
          this.Lead.motherPhoneNumber = this.Lead.motherPhoneNumber.replace(
            /[^a-zA-Z0-9]/g,
            ""
          );
        }

        if (this.Lead.emergencyPhoneNumber) {
          this.Lead.emergencyPhoneNumber =
            this.Lead.emergencyPhoneNumber.replace(/[^a-zA-Z0-9]/g, "");
        }
        this.loading = true;
        return LeadService.update(this.Lead.id, this.Lead)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Lead is updated",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
